export const TAB_FONTS = {
    normal: {
        fontName: 'h4-regular',
        variantName: 'h4-semibold',
    },
    small: {
        fontName: 'body-regular-dove',
        variantName: 'body-semibold-dove',
    },
};
export const TAB_SIZES = {
    normal: 'normal',
    small: 'small',
};
export const TAB_UNDERLINE_SPACING_SIZES = {
    large: '12px',
    normal: '2px',
};
export var TAB_UNDERLINE_SIZES;
(function (TAB_UNDERLINE_SIZES) {
    TAB_UNDERLINE_SIZES["LARGE"] = "large";
    TAB_UNDERLINE_SIZES["NORMAL"] = "normal";
})(TAB_UNDERLINE_SIZES || (TAB_UNDERLINE_SIZES = {}));
//# sourceMappingURL=constants.js.map